<template>
  <div>
    <draggable 
      key="manual"
      group="manuals"
      :list="list"
      direction="vertical"
      handle=".row-drag-handle"
      @change="$emit('sortChanged', $event)"
    >
      <div v-for="(row, i) in list" :key="'m'+i">
        <!-- 項目が完了していないもしくは完了画面 -->
        <div v-if="(!row.complete || !completeBtn)" class="mt-6 mb-10">
          <div class="flex w-full mb-1">
            <!-- No -->
            <div v-if="!canEdit" class="font-bold text-blue-700 self-center w-14">No. {{ row.manualSort }}</div>
            <div v-else-if="!sortableItem" class="font-bold text-blue-700 self-center w-14">No. {{ i + 1 }}</div>
            <div v-else class="font-bold text-blue-700 self-center w-14 row-drag-handle">（{{ i + 1 }}）</div>
            <!-- 項目（編集可） -->
            <div v-if="!row.manualNotEdit && canEdit" class="w-full flex">
              <input
                type="text"
                placeholder="内容"
                v-model="row.item"
                class="border-gray-300 focus:bg-yellow-100 focus:ring-indigo-500 focus:border-indigo-500 rounded text-blue-700 mb-1 h-8 w-full font-bold py-1.5"
                @change="$emit('temporarilyRegister', 'manual' + type, row)"
              />
              
              <!-- 削除 -->
              <div @click="$emit('deleteManual', i, type, row)" class="ml-0.5 my-auto">
                <TrashIcon class="text-gray-400 cursor-pointer hover:text-gray-500 active:text-gray-600 w-7 h-7" />
              </div>
            </div>
            <!-- 項目（編集不可） -->
            <div v-else class="font-bold text-blue-700">
              {{ row.item }}
            </div>
          </div>

          <div class="ml-14 mr-5">
            <!-- ボタン -->
            <div class="flex justify-start items-stretch">
              <PrimaryButton text="問題あり" size="normal" class="w-60 mr-2" :class="row.value!='0'?'bg-gray-400':''" :disabled="start==''||!canEdit" @click="$emit('setPoint', '0', row)" />
              <PrimaryButton text="問題なし" size="normal" class="w-60 mr-5" :class="row.value!='1'?'bg-gray-400':''" :disabled="start==''||!canEdit" @click="$emit('setPoint', '1', row)" />
              <!-- カメラ -->
              <div v-if="canEdit" class="flex ml-auto">
                <div class="file-btn rounded w-70px h-full mr-1">
                  <PrimaryButton :buttonContents="'要'" class="bg-blue-700 hover:bg-darkgreen h-full w-70px p-1">
                    <Icon slot="before" iconName="FolderDownload" iconType="outline" :strokeWidth="2" class="text-white h-7 w-8 bg-blue-700 hover:bg-darkgreen" />
                  </PrimaryButton>
                  <input class="file-type w-70px bg-darkgreen" type="file" accept="image/*" @change="$emit('imageToBase64', row, $event, true, 'manual' + type)" multiple :disabled="!start" />
                </div>
                <div class="file-btn rounded w-70px bg-darkgreen h-full">
                  <PrimaryButton :buttonContents="'要'" class="bg-darkgreen hover:bg-darkgreen h-full w-70px">
                    <Icon slot="before" iconName="Camera" iconType="solid" :strokeWidth="2" class="text-white h-5 w-8 bg-darkgreen hover:bg-darkgreen" />
                  </PrimaryButton>
                  <input class="file-type w-70px bg-darkgreen" type="file" accept="image/*" capture="environment" @change="$emit('imageToBase64', row, $event, false, 'manual' + type)" multiple :disabled="!start" />
                </div>
              </div>
              <!-- 完了ボタン -->
              <PrimaryButton v-if="canEdit && row.complete && compareDate(row.updateDate, today)" :text="formatDate(row.updateDate)" size="bg-cbl" class="text-white rounded font-bold p-6p ml-3 w-59px cursor-not-allowed relative z-50" />
              <PrimaryButton v-else-if="canEdit" buttonContents="要" :text="processing?'':'完了'" size="bg-blue-50" class="comp-btn text-blue-800 border border-blue-800 rounded font-bold p-6p ml-3 w-59px" @click="$emit('completeManual', row, type)" :disabled="processing" >
                <LoadingIcon v-if="processing" slot="before" class="h-4 w-4 text-blue-600" />
              </PrimaryButton>
              <div v-if="!canEdit" class="text-sm text-gray-800 p-1 ml-auto self-center min-w-fit">{{ formatDate(row.updateDate) }} 完了</div>
            </div>

            <!-- コメント -->
            <textarea
              v-if="canEdit&&row.value=='0'"
              placeholder="コメント"
              :rows="2"
              class="border-gray-300 rounded w-full my-2"
              style="field-sizing: content;"
              v-model="row.cleaningText"
              @change="$emit('temporarilyRegister', 'manual' + type, row)"
            ></textarea>
            <div v-else-if="!canEdit&&row.cleaningText" class="border border-gray-300 rounded w-full py-1.5 px-3 whitespace-pre-line my-2 bg-white">
              {{ row.cleaningText }}
            </div>

            <!-- 添付画像 -->
            <div v-if="(!row.complete || !completeBtn)">
              <div class="mt-2 flex flex-wrap">
                <div v-for="(p, j) in list[i].photo" :key="'p'+j" class="flex mr-3 w-30per mb-5">
                  <div class="">
                    <a :href="p" :data-lightbox="type + 'manu' + i">
                      <img :src="p">
                    </a>
                    <div class="flex">
                      <!-- 左へボタン -->
                      <Icon
                        v-if="j!=0&&list[i].photo.length!=1&&canEdit"
                        iconName="ArrowNarrowLeft" 
                        :clickable="true" 
                        class="mt-0.5 cursor-pointer text-gray-600 border rounded w-fit py-1 px-3 border-gray-400 bg-gray-50"
                        @click="$emit('toLeft', row, j)"
                      />
                      <!-- 右へボタン -->
                      <Icon
                        v-if="j!=list[i].photo.length-1&&list[i].photo.length!=1&&canEdit"
                        iconName="ArrowNarrowRight" 
                        :clickable="true" 
                        class="mt-0.5 cursor-pointer text-gray-600 border rounded w-fit py-1 px-3 border-gray-400 bg-gray-50"
                        @click="$emit('toRight', row, j)"
                      />
                    </div>
                    
                  </div>
                  <!-- 削除 -->
                  <div @click="$emit('deletePhoto', row, j, 'manual' + type)" v-if="p && p != '' && canEdit" class="ml-0.5 mb-auto mt-1">
                    <TrashIcon class="text-gray-400 cursor-pointer hover:text-gray-500 active:text-gray-600 w-7 h-7" />
                  </div>
                </div>

                <!-- 前回の写真 -->
                <div v-if="canEdit && row.lastPhoto && row.lastPhoto.length" class="w-1/5 ml-auto p-1 bg-light-blue-100">
                  <div class="text-xs mb-1 text-center">
                    前回
                  </div>
                  <div v-for="(lp, k) in row.lastPhoto" :key="'lp'+ k" class="flex mx-1">
                    <a :href="lp" :data-lightbox="i * 200" class="mb-1">
                      <img :src="lp" width="200">
                    </a>
                  </div>
                  <!-- 前回のコメント -->
                  <div v-if="row.lastNote" class="text-xs whitespace-pre-line">
                    {{ row.lastNote }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </draggable>
    <div class="text-transparent">{{reload}}</div>
  </div>
</template>
<script>
import Icon from '@components/Icon.vue'
import { TrashIcon } from '@vue-hero-icons/solid'
import PrimaryButton from '@components/PrimaryButton.vue'
import draggable from "vuedraggable"
import LoadingIcon from '@assets/loading-circle.svg' 
import moment from 'moment'

export default {
  components: {
    Icon,
    TrashIcon,
    PrimaryButton,
    draggable,
    // Toggle,
    // WmsSuggestInput,
    // ItemHistorySettingModal,
    // ProcessModal,
    // SelectToStringComponent,
    // ManualComponent,
    LoadingIcon
  },

  props: {
    // 項目
    list: {
      type: Array,
      default: () => []
    },

    // 編集可
    canEdit: {
      type: Boolean,
      default: false
    },

    /**
     * 項目の完了ボタンが押されたか否か
     */
    completeBtn: {
      type: Boolean,
      default: false
    },

    // ローディング中
    processing: {
      type: Boolean,
      default: false
    },

    // スタートボタン押下済み
    start: {
      default: null
    },

    // 物件に関する：1、人に関する：2
    type: {
      type: Number,
      default: 1
    },

    // 即時反映
    reload: {
      type: Number,
      default: 0
    },

    // 並べ替え
    sortableItem: {
      type: Boolean,
      default: false
    }
  },

  // computed: {
  // },

  // watch: {
  //   value() {
  //     this.getOther()
  //   },
  // },

  data() {
    return {
      today: moment().format('YYYY-MM-DD')
    }
  },

  // created() {
  //   this.getOther()
  // },

  methods: {
    /**
     * 日付フォーマット
     * @param val 日付
     */
    formatDate(val) {
      return moment(val).format('M/D')
    },

    /**
     * 更新日が今日よりも過去の場合、true
     * @param val1 更新日
     * @param val2 今日
     */
    compareDate(val1, val2) {
      let v1 = Number(moment(val1).format('YYYYMMDD'))
      let v2 = Number(moment(val2).format('YYYYMMDD'))
      return v1 < v2
    },
  }
}
</script>

<style scoped>

.file-btn {
  /* border: 3px solid blue;
  background-color: rgb(75, 191, 152); */
  display: inline-block;
  position: relative;
}

.w-70px {
  width: 70px;
}

.file-type {
  height: 100%;
  left: 0;
  opacity: 0;
  position: absolute;
  top: 0;
}

/* safari用のスタイル */
_::-webkit-full-page-media,
_:future,
:root .file-type {
  height: 100%;
  top: 0;
  left: 0;
  width: 70px;
  opacity: 0;
  position: absolute;
}

/* safari用のスタイル */
_::-webkit-full-page-media,
_:future,
:root .comp-btn {
  position: relative;
  z-index: 50;
}

.p-6p {
  padding: 6px;
}

.bg-darkblue {
  background: #010178;
}

.bg-darkgreen {
  background: #010178;
}
</style>